import 'jquery';
import { viewportSize } from "../util/viewport";
import { throttle } from "throttle-debounce";
import Player from '@vimeo/player';

export default {
  init() {
    const selector = '[data-vimeo-id],[data-vimeo-url]';

    this.queue = [];
    this.loaded = [];
    this.complete = false;

    this.videos = document.querySelectorAll(selector);
    this.videos.forEach(item => this._initPlayer(item));

    this.videosFilling = Array.from(this.videos).filter(element => element.classList.contains('video-fill'));
    if (this.videosFilling.length) {
      $(window).on(
        "resize.video-ratio",
        throttle(200, () => this._adjustFillBase({elements: this.videosFilling}))
      );
      this._adjustFillBase({elements: this.videosFilling});
    }
  },

  finalize() {},

  _adjustFillBase({ elements = [], base = window } = {}) {
    const { ratio: baseRatio } = viewportSize();
    elements.forEach(element => {
      const ratio = element.dataset.ratio;
      if (ratio) {
        element.classList.toggle('fill-width', ratio > baseRatio);
      }
    });
  },

  _initPlayer(element) {
    const _ = this;
    const player = new Player(element);

    const $element = $(element);

    $element.data('row', $element.closest('.row'));

    if ($element.parent('.carousel-item')) {
      $element.data('carousel', $element.closest('.carousel'));
    }

    player.ready().then(() => {
      const match = player.element.src.match(/video\/(\d+)/);
      const id = parseInt(match[1], 10) || false;
      if (id) {
        _.queue.push(id);
      }

      $element.data('player', player);
    });

    player.setAutopause(true);

    player.on('loaded', data => {
      _.queue = _.queue.filter(id => id === data.id);
      _.loaded.push(data.id);
      if (_.loaded.length === _.videos.length) {
        _.complete = true;

        const video = _.videos[0];
        $(video)
          .data('player')
          .play();
        if ($element.data('carousel') && 'carousel' === $element.data('carousel').data('ride')) {
          window.console.log('Loaded', 'cycle');
          $element.data('carousel').carousel('cycle');
        }
      }
    });

    player.on('play', data => {
      if ($element.data('row')) {
        $element.data('row').addClass('video-is-playing');
      }
    });

    player.on('pause', data => {
      if ($element.data('row')) {
        $element.data('row').removeClass('video-is-playing');
      }
    });

    player.on('ended', data => {
      if ($element.data('row')) {
        $element.data('row').removeClass('video-is-playing');
      }
      if ($element.data('carousel')) {
        player.setCurrentTime(0).then(() => {
          window.console.log('Ended', 'cycle');
          return $element
            .data('carousel')
            .carousel('cycle')
            .carousel('next');
        });
      }
    });
  },
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/routes/hasVideo.js